import { MemreButton, MemreFlexBox } from 'components/core';
import React, { ChangeEvent, useRef } from 'react';
import { Block } from 'services/useItem.service/interactions/instructional_contents';
import { updateDocument } from 'utils/updateDocument';

interface PdfBlockProps {
  item: Block;
}

export default function PdfBlock({ item }: PdfBlockProps) {
  const fileInputRef = useRef<HTMLInputElement>(null);

  const handleButtonClick = () => {
    fileInputRef.current?.click();
  };

  const handleFileChange = async (event: ChangeEvent<HTMLInputElement>) => {
    if (event.target.files && event.target.files.length > 0) {
      const doc = await updateDocument(event.target.files[0]);
      item.setDocument(doc);
    }
  };

  return (
    <MemreFlexBox
      direction="column"
      gap={1}
      justify="center"
      align="center"
      sx={{ p: 0, flex: 1, position: 'relative' }}
    >
      <input type="file" style={{ display: 'none' }} accept=".pdf" onChange={handleFileChange} ref={fileInputRef} />
      {!item.url && <MemreButton variant="outlined" text="Add PDF" onClick={handleButtonClick} />}
      {item.url && (
        <>
          <div style={{ width: '100%', display: 'flex', justifyContent: 'flex-end' }}>
            <MemreButton variant="icon" iconName="trash" onClick={() => item.setDocument(null)} />
          </div>
          <iframe src={item.url} title="PDF Viewer" style={{ width: '100%', height: '500px', border: 'none' }} />
        </>
      )}
    </MemreFlexBox>
  );
}
